export const capitalizeWords = (str = "") => {
  if (typeof str !== "string") return "";

  const trimmed = str.trim();
  if (!trimmed) return "";

  return trimmed
    .split(" ")
    .map((word, index) => {
      if (index === 0) {
        return word.charAt(0).toUpperCase() + word.slice(1);
      }
      return word;
    })
    .join(" ");
};
